import { ReactNode, useEffect, useRef, useState } from "react";
import cn from "classnames";

import styles from "./DescriptionCollapseField.module.scss";
import { useIsMobile } from "~/hooks";

interface DescriptionCollapseFieldProps {
  content: ReactNode;
  trigger: boolean;
  tooltipMsg?: string;
}

export const DescriptionCollapseField = ({
  content,
  trigger,
  tooltipMsg,
}: DescriptionCollapseFieldProps) => {
  const isMobile = useIsMobile();
  const [descriptionHeight, setDescriptionHeight] = useState(0);
  const descriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const calculateHeight = () => {
      if (descriptionRef.current) {
        setDescriptionHeight(descriptionRef.current.scrollHeight);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      calculateHeight();
    });

    if (descriptionRef.current) {
      resizeObserver.observe(descriptionRef.current);
      calculateHeight();
    }

    return () => resizeObserver.disconnect();
  }, [content]);

  if (!content) {
    return null;
  }

  return (
    <div
      ref={descriptionRef}
      className={cn(styles.container, {
        [styles.expanded]: trigger,
        [styles.collapsed]: !trigger,
      })}
      style={{
        maxHeight: trigger ? `${descriptionHeight}px` : "0px",
        marginBottom: 24
      }}
    > 
      {isMobile && <p className={styles.tooltip}>{tooltipMsg}</p>}
      {content}
    </div>
  );
};
